import { convertTaskFromServer } from "../../utils/task";
import { REMOVE_ASSIGNABLE_TASK, SET_ASSIGNABLE_TASKS, SET_ASSIGNABLE_TASKS_LOADING, } from "../constants";
const reducer = (state, action) => {
    switch (action.type) {
        case SET_ASSIGNABLE_TASKS_LOADING: {
            const loading = action.payload;
            return Object.assign(Object.assign({}, state), { loading });
        }
        case SET_ASSIGNABLE_TASKS: {
            const tasks = action.payload;
            return Object.assign(Object.assign({}, state), { assignableTasks: tasks.map(convertTaskFromServer) });
        }
        case REMOVE_ASSIGNABLE_TASK: {
            const taskId = action.payload;
            return Object.assign(Object.assign({}, state), { assignableTasks: state.assignableTasks.filter((task) => task.id !== taskId) });
        }
        default: {
            return state;
        }
    }
};
export { reducer };
